<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <a-modal :title="title" :visible.sync="visible" @ok="handleOk" @cancel="reset" width="800px">
      <div v-for="item,index in voteResults" :key="index">
        <div>{{vote_titles[index]}}</div>
        <div>
          <a-table size="small" :bordered="false" :pagination="false" :data-source="item" rowKey="id">
                    <a-table-column title="序号" data-index="index" width="10%" align="center">
                    <template slot-scope="text, record, index">{{ index + 1 }}</template>
                    </a-table-column>
                    <a-table-column title="专家姓名" data-index="index" width="30%" align="center">
                    <template slot-scope="text, record">{{ expert_names[record.vote_username] }}</template>
                    </a-table-column>
                    <a-table-column title="投票结果" data-index="index" width="30%" align="center">
                    <template slot-scope="text, record">{{ option_names[record.choose_option_id] }}</template>
                    </a-table-column>
                    <a-table-column title="投票时间" data-index="index" width="30%" align="center">
                    <template slot-scope="text, record">{{ record.update_time }}</template>
                    </a-table-column>
         </a-table>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  name: 'vote-result-edit',
  data() {
    return {
      title: '投票明细',
      visible: false,
      vote_titles: {},
      option_names: {},
      expert_names: {},
      voteResults: undefined,
    }
  },
  methods: {
    //打开编辑窗口
    open(record, vote_titles, option_names, expert_names) {
      if (record) {
        this.voteResults = record
        this.vote_titles = vote_titles
        this.option_names = option_names
        this.expert_names = expert_names
      }
      this.visible = true
    },
    handleOk() {
      this.visible = false
    },
    reset() {
      this.visible = false
    },
  },
}
</script>
<style></style>
